import { Component, Prop } from "vue-property-decorator";
import BaseBlock from "@/blocks/base-block";
import LocationPreview from "@/components/location-preview/location-preview";
import { LocationDTO } from "@/model/LocationDTO";
import { ApartmentLocationsFilterDTO } from '@/model/ApartmentLocationsFilterDTO';
import { LocationStatsDTO } from '../../../model/LocationStatsDTO';
import { Block } from '../../../helpers/components';
import { apartmentsLocationsLocationData } from './apartments-locations-location.data';

import { sortBy, debounce } from 'lodash-es';

@Block(apartmentsLocationsLocationData)
@Component({
	components: {
		LocationPreview
	}
})
export class ApartmentsLocationsLocationBlock extends BaseBlock {
	@Prop() locations: LocationDTO[];
	@Prop() locationStats: LocationStatsDTO[];

	get locationsToShow(): LocationDTO[] {
		let locations = this.locations;
		
		const filter = { ...this.$route.query} as ApartmentLocationsFilterDTO;

		if (filter.cityId) {
			const cityId = parseInt(filter.cityId);
			locations = locations.filter(l => cityId === l.cityId);
		}

		if (filter.cityPartId) {
			const cityPartId = parseInt(filter.cityPartId);
			locations = locations.filter(l => cityPartId === l.cityPartId);
		}
	 
		locations = sortBy(locations, ["order"]);
		locations = sortBy(locations, l => this.getLocationStats(l) == null ? 1 :this.getLocationStats(l).isNew ? 0 : 1);

		return locations;
	}

	getLocationStats(location: LocationDTO) {
		return this.locationStats.find(
			ls => ls.locationId === location.id
				&& ls.premiumVariant === location.isPremium
				&& ls.catalogMarketingNumber === location.catalogMarketingNumber
		);
	}
}

export default ApartmentsLocationsLocationBlock;
